import type { FmSentCounts, FmSentFilter, FmSentFormRow } from './types';

export const FM_SENT_FILTERS: { key: FmSentFilter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'needs_review', label: 'Needs review' },
  { key: 'with_patient', label: 'With patient' },
  { key: 'synced', label: 'Synced' },
  { key: 'incomplete', label: 'Incomplete' },
];

function matchesFilter(row: FmSentFormRow, filter: FmSentFilter): boolean {
  switch (filter) {
    case 'all':
      return true;
    case 'needs_review':
      return row.assignmentStatus === 'submitted';
    case 'with_patient':
      return row.assignmentStatus === 'pending' || row.assignmentStatus === 'in_progress';
    case 'synced':
      return row.syncStatus === 'synced';
    case 'incomplete':
      return (
        row.assignmentStatus === 'incomplete' ||
        row.assignmentStatus === 'cancelled' ||
        row.assignmentStatus === 'expired'
      );
  }
}

export function fmSentCounts(rows: FmSentFormRow[]): FmSentCounts {
  return {
    all: rows.length,
    needs_review: rows.filter((r) => matchesFilter(r, 'needs_review')).length,
    with_patient: rows.filter((r) => matchesFilter(r, 'with_patient')).length,
    synced: rows.filter((r) => matchesFilter(r, 'synced')).length,
    incomplete: rows.filter((r) => matchesFilter(r, 'incomplete')).length,
  };
}

/** Filter by status bucket and a free-text match on patient or form name. Order is preserved. */
export function fmFilterSentForms(
  rows: FmSentFormRow[],
  filter: FmSentFilter,
  search: string,
): FmSentFormRow[] {
  const q = search.trim().toLowerCase();
  return rows.filter((row) => {
    if (!matchesFilter(row, filter)) return false;
    if (q === '') return true;
    return (
      row.patientName.toLowerCase().includes(q) || row.formName.toLowerCase().includes(q)
    );
  });
}
